/** Regras de slug: `<slug>.sites.oniochat.com.br`. */
/** Subdomínios que nunca são farmácia (infra, ACME, apex, painel). */
export const RESERVED_SLUGS = new Set([
    "admin",
    "www",
    "sites",
    "api",
    "painel",
    "app",
    "_acme-challenge",
    "acme-challenge",
]);
/** RFC-1123-ish: minúsculas, dígitos e hífen; sem hífen nas pontas; 3–63 chars. */
export const SLUG_RE = /^[a-z0-9](?:[a-z0-9-]{1,61}[a-z0-9])$/;
export function isValidSlug(slug) {
    return SLUG_RE.test(slug) && !RESERVED_SLUGS.has(slug);
}
/** Deriva um slug a partir de um nome fantasia (sem garantia de unicidade). */
export function slugify(input) {
    return (input ?? "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
        .slice(0, 63)
        .replace(/-+$/g, "");
}
/**
 * Extrai o slug de um header `Host`. Retorna `null` para o apex, domínios que
 * não batem com `baseDomain`, ou slugs reservados.
 */
export function slugFromHost(host, baseDomain) {
    if (!host)
        return null;
    const hostname = host.split(":")[0].trim().toLowerCase().replace(/\.$/, "");
    const suffix = `.${baseDomain.toLowerCase()}`;
    if (!hostname.endsWith(suffix))
        return null;
    const label = hostname.slice(0, -suffix.length);
    if (!label || label.includes("."))
        return null; // sem multi-nível
    if (RESERVED_SLUGS.has(label))
        return null;
    if (!SLUG_RE.test(label))
        return null;
    return label;
}
//# sourceMappingURL=slug.js.map